import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
  pure: false
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], valor:string ): any {
    if(!items) return []
    if(!valor) return items
    return items.filter(
      item =>{
        return item.get('estado').value == valor
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/filters/search.pipe.ts